import styled from "styled-components";
import { InfoCircleOutlined } from "@ant-design/icons/lib";
import {
  BORDER_RADIUS,
  FONT_SIZE,
  FONT_WEIGHT,
  media,
} from "styles/themes/constants";
import { BaseTypography } from "components/common/BaseTypography";

export const LegendWrapper = styled.div`
  display: flex;
  padding: 0.5rem;
`;

export const LegendInfo = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  color: var(--text-superLight-color);
`;

export const LegendDescription = styled.div`
  display: flex;
`;

export const LegendColor = styled.span`
  height: 1rem;
  width: 1rem;
  min-width: 1rem;
  border-radius: 50%;
`;

export const LegendTitle = styled.div`
  line-height: 1rem;
  font-weight: ${FONT_WEIGHT.semibold};
  color: var(--text-main-color);
  display: flex;
  justify-content: space-between;

  @media only screen and ${media.xs} {
    font-size: ${FONT_SIZE.xs};
  }

  @media only screen and ${media.md} {
    font-size: ${FONT_SIZE.xs};
  }
`;

export const Values = styled.div`
  display: flex;
  align-items: center;
  margin-left: 0.5rem;
  color: var(--primary-color);

  @media only screen and ${media.md} {
    margin-left: 1.5rem;
  }
`;

export const SkeletonWrapperStyled = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;

  & > button {
    display: flex;
    align-items: center;

    position: absolute;
    right: 0px;
    top: 0px;
    & .icons {
      margin-right: 5px;
    }
  }
`;

export const ImgWrapper = styled.div`
  height: 230px;
  margin-bottom: 10px;

  & .ant-avatar > img {
    object-fit: contain;
  }
`;

export const Title = styled(BaseTypography.Text)`
  font-size: 1.125rem;
  font-weight: 700;
  color: #666;
  @media only screen and ${media.xl} {
    font-size: 1.5rem;
  }
`;

export const SubtitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
`;

export const Subtitle = styled(BaseTypography.Text)`
  margin-bottom: 2rem;
  color: #666;
  display: flex;
  align-items: center;

  @media only screen and ${media.xl} {
    font-weight: 600;
    font-size: 1rem;
    margin-bottom: 0.5rem;
  }
  & .label {
    color: #777;
    width: 120px;
  }
  &.desc {
    border-top: 1px solid #ccc;
    padding: 10px 0px 0px;
    max-width: 700px;
    overflow-wrap: break-word;
  }
`;
